
import { form14StatusInfoType } from '@/types/Information/Form14';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form14ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form14StatusInfoType;

}
